









import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { MobileGetter } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class Recognition extends Vue {
  private isMobile!: MobileGetter;

  private get mobile(): boolean {
    return this.isMobile(this.$mq);
  }
}
